import React, { useEffect, useState } from "react";
import { Avatar, Card, Col, Flex, Row, Space, Table, Typography } from "antd";
import Title from "antd/es/typography/Title";
import { GetCardLayout } from "../../../common/getCardLayout";
import { colors } from "../../../../constants/colors";
import { useTranslation } from "react-i18next";
import { getServiceProviderAppointmentsAction } from "../../../../redux/services/service-provider-appointments/serviceProviderAppointmentsServices";
import { useDispatch, useSelector } from "react-redux";
import {
  dateObjToDispViewDate,
  timeObjToDispViewTimeWithSuffix,
} from "../../../../utils/utils";
import dayjs from "dayjs";
import { routes, userRoles } from "../../../../constants";
import useLocalStorage from "../../../../hooks/useLocalStorage";
import { appConfig } from "../../../../constants/config/appConfig";
import { StaffDAppointmentIcon } from "../../../../assets/svg";
import Actions from "../../../../redux/actions";
import { baseRouteMaker } from "../../../../constants/routeConsts";
import { useNavigate } from "react-router-dom";
import { UserOutlined } from "@ant-design/icons";
import styles from "./StaffDashboard.module.scss";

const Dashboard = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {userSession, setUserSession} = useLocalStorage(appConfig.SESSION_USER_INFO);
  const [columns, setColumns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [viewDialogOpen, setViewDialogOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState({});
  const { serviceProviderAppointmentsInfo } = useSelector(
    (state) => state.serviceProviderAppointments
  );

  const showRowDetails = (record) => {
    setSelectedRowData(record);
    setViewDialogOpen(true);
  };

  const handleGetTableData = () => {
    const dataToBeSent = { page: 1, 
      limit: 500,
      // order_status: [
      //   "ASSIGNED_TO_SERVICE_PROVIDER",
      //   "APPROVED_BY_SERVICE_PROVIDER",
      // ],
      staff:userSession?.userRole === userRoles.SERVICE_PROVIDER_ADMIN ? "" : userSession?.userId,
      staffType : userSession?.userRole === userRoles.SERVICE_PROVIDER_ADMIN ? "" : userSession?.userRole,
      service_status:"APPROVED"
     };
    dispatch(getServiceProviderAppointmentsAction(dataToBeSent, setLoading));
  };

  useEffect(() => {
    handleGetTableData();
  }, []);

  /* initial dependencies rendering */
  useEffect(() => {
    /* table column config */
    const tempTableColumns = [
      {
        title:  t("Modules.Appointments.appointmentDate"),
        dataIndex: "appointment_date",
        key: "appointment_date",
        render: (_, record) => (
          <p>{ record?.appointment_date ? dateObjToDispViewDate(record?.appointment_date, "ddmmyyyy") : <>-</>}</p>
        ),
      },
      {
        title:  t("Modules.Appointments.appointmentTime"),
        dataIndex: "appointment_date_time",
        key: "appointment_date_time",
        render: (_, record) => (
          <p>
            {record?.appointment_date_time ?
              timeObjToDispViewTimeWithSuffix(dayjs(record?.appointment_date_time).utc().local().format('ddd, MMM D, H:mm z')): <>-</>}
          </p>
        ),
      },
      {
        title:  t("Modules.Appointments.appointmentMode"),
        dataIndex: "appointment_mode",
        key: "appointment_mode",
      },
      {
        title: t("Modules.Appointments.customerName"),
        dataIndex: "name",
        key: "name",
        render: (_, record) => (
          <Flex gap="1rem" align="center">
            {record?.booking_for_details ? (
              <>
                <Avatar
                  src={record?.user?.profile_image}
                  key={record?.user?.profile_image}
                  icon={<UserOutlined />}
                />
                {`${record?.booking_for_details?.first_name} ${record?.booking_for_details?.last_name}`}
              </>
            ):<>-</>}
          </Flex>
        ),
      },
      {
        title: t("Modules.Ads.service"),
        dataIndex: "service_name",
        key: "service_name",
        render: (_, record) => (
          <p>{record?.service_name ? record?.service_name : "-"}</p>
        ),
      },
      {
        title: t("Modules.customer.customerInfo"),
        key: "action",
        align: "center",
        render: (_, record) => {
          return (
            <>
              <Typography.Link onClick={(e) => handleViewDetails(e, record)}>
                View
              </Typography.Link>
            </>
          );
        },
      },
    ];
    /* table column config */
    setColumns(tempTableColumns);
  }, []);
  /* initial dependencies rendering */

  const handleViewDetails = (e, row) => {
    dispatch(
      Actions.createAction(Actions.SELECTED_APPOINTMENTS_INFO_ID, {
        selectedAppointmentsInfoId: "",
      })
    );
    navigate(baseRouteMaker(routes.SERVICE_INFO_LIST));
    if (
      row?._id &&
      row?._id !== "" &&
      row?._id !== null &&
      row?._id !== undefined
    ) {
      const selectedAppointmentsInfoId = row?._id;
      dispatch(
        Actions.createAction(Actions.SELECTED_APPOINTMENTS_INFO_ID, {
          selectedAppointmentsInfoId,
        })
      );
    }
  };

  /* Card Component - Section 1 */
  const CardComponent = () => {

    const staffCardDataInfo = [
      {
        icon: <StaffDAppointmentIcon />,
        title: t('weekAppt'),
        backgroundColor: "#06EC80",
        count: serviceProviderAppointmentsInfo?.total,
      },
    ];

    return (
      <>
        <Row gutter={16}>
          {staffCardDataInfo?.map((item, index) => (
            <Col xs={24} sm={12} md={8} lg={8} key={index}>
              <Card
                hoverable
                style={{
                  backgroundColor: item?.backgroundColor,
                  borderRadius: "20px",
                }}
              >
                <Flex gap="1rem">
                  {item?.icon}
                  <Flex vertical>
                    <Title level={4} style={{ color: colors.white }}>
                      {item?.title} 
                    </Title>
                    <Title level={1} style={{ margin: 0, color: colors.white }}>
                      {item?.count}
                    </Title>
                  </Flex>
                </Flex>
              </Card>
            </Col>
          ))}
        </Row>
      </>
    );
  };
  /* Card Component - Section 1 */

  /* Customers Component - Section 2 */
  const CustomersComponent = () => {
    return (
      <>
        <GetCardLayout style={{ height: "370px" }}>
          <Table
            dataSource={serviceProviderAppointmentsInfo?.data}
            columns={columns}
            pagination={false}
            style={{ overflow: "auto", height: "270px" }}
          />
        </GetCardLayout>
      </>
    );
  };
  /* Customers Component - Section 2 */

  return (
    <>
      <div className={styles.dashboardMainContainer}>
        <Flex vertical gap="2rem">
          <CardComponent />
          <CustomersComponent />
        </Flex>
      </div>
    </>
  );
};

export default Dashboard;
